/**
 * @author Harshitha.k
 * @description 
 */

import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import ImgCrop from 'antd-img-crop';
import { connect } from 'react-redux';
import Highlighter from 'react-highlight-words';
import SiteRoleComponents from './SiteRoleComponent';
import localStorage from '../../../../utils/localStorage';
import constants from '../../../../constants/config.json';
import StyledTable from '../../../../commons/styles/table';
import { DrawerFooter } from '../../../../commons/styles/layout';
import {
  Input,
  Drawer,
  Button,
  message,
  Select,
  Popconfirm,
  Divider,
  Form,
  Tooltip,
  Upload,
  Dropdown,
  Menu
} from 'antd';
import {
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
  RetweetOutlined,
  LoadingOutlined,
  SearchOutlined,
  UploadOutlined,
  DownloadOutlined
} from '@ant-design/icons';
import {
  API_AUTH,
  DEPARTMENT,
  GETUSERLIST,
  IPAddress,
  MEMBER,
  SAMPLE
} from '../../../../commons/api';

const { Option } = Select;
const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
};

const User = (props) => {
  const [visible, setVisible] = useState(false);
  const [visible1, setVisible1] = useState(false);
  const [filename, setFilename] = useState("");
  const [datasource, setDatasource] = useState([]);
  const [editObj, setEditObj] = useState({});
  const [roleEdge, setRoleEdge] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [imageUrl, setImageUrl] = useState([]);
  const [translationCache, setTranslationCache] = useState(props.translationCache || []);
  const searchInputRef = useRef();

  const width = 250;
  const height = 250;

  const userRef = useRef(null);
  useEffect(() => {
    _getUserList();
    _getDepartmentList();
  }, []);

  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
  }, [props.translationCache]);

  const _getDepartmentList = async () => {
    try {
      const siteId = localStorage.get('currentSite');
      const accessToken = localStorage.get('accessToken');
      const response = await axios.get(`${DEPARTMENT.GET}?SiteId=${siteId}`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      setDepartmentList(response.data);
    } catch (error) {
      console.log(error);
    }
  };


  // Fetch user list
  const _getUserList = async () => {
    try {
      const siteId = localStorage.get('currentSite');
      const accessToken = localStorage.get('accessToken');
      const response = await axios.get(`${GETUSERLIST.GET}?SiteId=${siteId}`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      setDatasource(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  // Fetch user by ID
  const _getUserListById = async (Id) => {
    try {
      const siteId = localStorage.get('currentSite');
      const accessToken = localStorage.get('accessToken');
      const response = await axios.get(`${GETUSERLIST.GET}?SiteId=${siteId}&Id=${Id}`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  const _createUser = async (e) => {
    e.preventDefault();
    try {
      const values = await userRef.current.validateFields();
      const siteId = localStorage.get('currentSite');

      if (
        roleEdge &&
        roleEdge[0] &&
        roleEdge[0].SiteId &&
        roleEdge[0].RoleId &&
        Array.isArray(roleEdge[0].RoleId) &&
        roleEdge[0].RoleId.length > 0 &&
        roleEdge[0].SiteId !== null
      ) {
        let saveObject = {
          ...values,
          Password: constants.defaultPassword,
          ConfirmPassword: constants.defaultPassword,
          SiteId: siteId
        };
        delete saveObject['RoleId'];

        let saveObjects = await _createUserAPI(saveObject);
        if (saveObjects) {
          for (let i = 0; i < roleEdge.length; i++) {
            let newObj = {
              ...roleEdge[i],
              UserId: saveObjects.id
            };
            await _linkSiteRole(newObj, 'create');
          }
        }
      } else {
        message.error('Please add site and role before submitting');
      }
    } catch (error) {
      console.log(error);
    }
  };

  const _updateUser = async (e) => {
    e.preventDefault();
    try {
      const values = await userRef.current.validateFields();
      values['Id'] = editObj.Id;
      delete values['RoleId'];
      delete values['SiteId'];
      delete values['upload'];

      if (
        roleEdge &&
        roleEdge[0] &&
        roleEdge[0].SiteId &&
        roleEdge[0].RoleId &&
        Array.isArray(roleEdge[0].RoleId) &&
        roleEdge[0].RoleId.length > 0 &&
        roleEdge[0].SiteId !== null
      ) {
        let updateObjects = await _updateUserAPI(values);
        if (updateObjects) {
          for (let i = 0; i < roleEdge.length; i++) {
            let newObj = {
              ...roleEdge[i],
              UserId: updateObjects.id
            };
            await _linkSiteRole(
              newObj,
              roleEdge[i] && roleEdge[i].Id ? 'update' : 'create'
            );
          }
        }
      } else {
        message.error('Please add site and role before updating user');
      }
    } catch (error) {
      console.log(error);
    }
  };

  const _linkSiteRole = async (payload, operation) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const orgCreateHeaders = {
      method: operation === 'create' ? 'POST' : 'PATCH',
      url: operation === 'create' ? `${MEMBER.CREATE}?SiteId=${siteId}` : `${MEMBER.Update}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: payload
    };

    try {
      await axios(orgCreateHeaders);
      await _getUserList();
    } catch (error) {
      console.log(error);
    }
  };

  const _updateUserAPI = async (updateObject) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const orgUpdateHeaders = {
      method: 'PATCH',
      url: `${GETUSERLIST.UPDATE}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: updateObject
    };

    try {
      const response = await axios(orgUpdateHeaders);
      message.success(response?.data?.message || '');
      await _getUserList();
      _cancel(); // Assuming _cancel is defined elsewhere in your component
      return response.data;
    } catch (error) {
      if (error.response && (error.response.status === 400 || error.response.status === 500)) {
        message.info(error.response.data.message);
      }
    }
  };

  const _createUserAPI = async (createObject) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const orgCreateHeaders = {
      method: 'POST',
      url: `${GETUSERLIST.CREATE}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: createObject
    };

    try {
      const response = await axios(orgCreateHeaders);
      message.success(response?.data?.message || '');
      await _getUserList();

      // Close the modal or reset visibility if applicable
      setVisible(false); // Assuming you have a state variable for visibility
      if (userRef.current) {
        userRef.current.resetFields();
      }

      return response.data;
    } catch (error) {
      if (error.response && (error.response.status === 400 || error.response.status === 500)) {
        message.info(error.response.data.message);
      }
    }
  };

  const openModal = () => {
    if (userRef.current) {
      userRef.current.resetFields();
    }
    setVisible(true);
    setRoleEdge([]);
    setEditObj({});
  };

  const _cancel = () => {
    if (userRef.current) {
      userRef.current.resetFields();
    }
    setVisible(false);
    setEditObj({});
  };

  const editUser = async (editObj) => {
    try {
      const roleEdgeData = await getSiteRole(editObj.Id); // Implement this function to get site role
      if (userRef.current) {
        userRef.current.setFieldsValue(editObj);
      }
      setEditObj(editObj);
      setRoleEdge(roleEdgeData ? [roleEdgeData] : []);
      setVisible(true);
      setImageUrl(editObj.ImageURL);
    } catch (error) {
      // message.error('Failed to fetch site role');
      console.error(error);
    }
  };

  const getSiteRole = async (UserId) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const headers = {
      method: 'GET',
      url: `${MEMBER.Get}?SiteId=${siteId}&UserId=${UserId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };

    try {
      const response = await axios(headers);
      return response.data;
    } catch (error) {
      if (error.response && (error.response.status === 400 || error.response.status === 500)) {
        message.info(error.response.data.message);
      }
    }
  };

  const deleteUser = async (Id) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const orgDeleteHeaders = {
      method: 'DELETE',
      url: `${GETUSERLIST.Delete}?SiteId=${siteId}&Id=${Id}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };

    try {
      const response = await axios(orgDeleteHeaders);
      if (response.status === 200 || response.status === 204) {
        message.success(response && response.data && response.data.message);
        await _getUserList();
        setVisible(false);
      }
    } catch (error) {
      if (error.response && (error.response.status === 400 || error.response.status === 500)) {
        message.info(error.response.data.message);
      }
    }
  };

  const add = () => {
    const newObj = {
      SiteId: '',
      RoleId: [],
      UserId: ''
    };
    if (Array.isArray(roleEdge)) {
      setRoleEdge([...roleEdge, newObj]);
    } else {
      setRoleEdge([newObj]);
    }
  };

  const handleFieldChange = (e, parameter, index) => {
    const arrayUpdated = updateArray(roleEdge, index, (item) => ({ ...item, [parameter]: e }));
    setRoleEdge(arrayUpdated);
  };

  const updateArray = (array, index, updateFn) => {
    return [
      ...array.slice(0, index),
      updateFn(array[index]),
      ...array.slice(index + 1)
    ];
  };

  const remove = (index, deleteObject) => {
    setRoleEdge((prevRoleEdge) => {
      const filtered = prevRoleEdge.filter((_, i) => i !== index);
      if (deleteObject && deleteObject.Id) {
        _unlinkSite(deleteObject.Id);
      }
      return filtered;
    });
  };

  const _unlinkSite = async (Id) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const orgDeleteHeaders = {
      method: 'DELETE',
      url: `${MEMBER.Delete}?SiteId=${siteId}&Id=${Id}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };

    try {
      await axios(orgDeleteHeaders);
      message.success('Site Unlinked');
    } catch (error) {
      console.log(error);
    }
  };

  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const renderFormSwitch = (renderFormItems) => {
    const { Widget, Placeholder, Key, Options, OptionsSettings, disableOnUpdate } = renderFormItems;

    switch (Widget) {
      case 'Select':
        return (
          <Select
            style={{ width: 300 }}
            placeholder={translation(`Select ${Placeholder}`)}
            disabled={editObj && editObj.Id && disableOnUpdate}
            onChange={(value) => {
              userRef.current.setFieldsValue({ [Key]: value });
            }}
          >
            {Options && Array.isArray(Options) && Options.map((option, index) => {
              if (OptionsSettings && OptionsSettings.key && OptionsSettings.value) {
                return (
                  <Option key={index} value={option[OptionsSettings.value]}>
                    {option[OptionsSettings.key]}
                  </Option>
                );
              }
              return (
                <Option key={index} value={option}>
                  {option}
                </Option>
              );
            })}
          </Select>
        );

      case 'InputNumber':
        return (
          <Input
            disabled={editObj && editObj.Id && disableOnUpdate}
            placeholder={translation(`Input ${Placeholder}`)}
            style={{ width: 300 }}
            onKeyPress={(event) => {
              if (!/[0-9]/.test(event.key)) {
                event.preventDefault();
                message.error('Please Use Numeric values');
              }
            }}
          />
        );

      default:
        return (
          <Input
            style={{ width: 300 }}
            placeholder={translation(`Input ${Placeholder}`)}
            disabled={editObj && editObj.Id && disableOnUpdate}
          />
        );
    }
  };
  const onFinishFailed = () => {
    message.error('please enter required fields');
  };

  const resetpassword = (user) => {
    let siteId = localStorage.get('currentSite');
    let accessToken = localStorage.get('accessToken');
    let data = {
      identifier: user.UserName,
      password: constants.defaultPassword,
      role:
        props.userProfile &&
          props.userProfile.belongsTo &&
          props.userProfile.belongsTo.sites &&
          props.userProfile.belongsTo.sites[siteId] &&
          props.userProfile.belongsTo.sites[siteId].role &&
          props.userProfile.belongsTo.sites[siteId].role.Id
          ? props.userProfile.belongsTo.sites[siteId].role.Id
          : ''
    };
    let orgHeaders = {
      method: 'POST',
      url: `${API_AUTH.ResetPassword}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data
    };
    axios(orgHeaders)
      .then((response) => {
        message.success(response.data.message);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleChange = async (info) => {
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }

    if (info.file.status === 'done') {
      const updatedEditObj = await _getUserListById(editObj.Id);
      const newEditObj = updatedEditObj && updatedEditObj[0] ? updatedEditObj[0] : {};

      const base64Image = await getBase64(info.file.originFileObj);

      setLoading(false);
      setEditObj(newEditObj);
      setImageUrl(newEditObj.ImageURL || base64Image);
    }
  };
  const beforeUpload = (file) => {
    const siteId = localStorage.get('currentSite');

    if (!siteId) {
      message.warn('Please select a picture');
      return false;
    }

    const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJPG) {
      message.error('You can only upload JPG or PNG files!');
      return false;
    }

    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error('Image must be smaller than 2MB!');
      return false; // Prevent upload if larger than 2MB
    }

    return true; // Allow upload if all checks pass
  };


  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const handleDownload = () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const Object = {
      method: 'GET',
      url: `${IPAddress.LOCAL}${GETUSERLIST.DOWNLOADFILENAME}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    return axios(Object)
      .then((response) => {
        window.location.href =(`${IPAddress.LOCAL}${GETUSERLIST.DOWNLOADFILE}/${response.data.file}`);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleMenuClick = (e) => {
    if (e.key === '1') {
      window.location.href = `${IPAddress.LOCAL}${SAMPLE.UserSample}`;
    } else if (e.key === '2') {
      handleDownload();
    }
    setVisible1(false);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInputRef}
          placeholder={translation(`Search ${dataIndex}`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          style={{ width: 90, marginRight: 8 }}
        >
          {translation('Search')}
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}
          style={{ width: 90 }}>
          {translation('Reset')}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInputRef.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    ),
  });

  const UserName = editObj.UserName;
  const userId =
    props.userProfile &&
      props.userProfile.user &&
      props.userProfile.user.Id
      ? props.userProfile.user.Id
      : '';
  const siteId = localStorage.get('currentSite');

  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div className="ant-upload-text">{translation('Upload')}</div>
    </div>
  );
  const formItems =
    roleEdge &&
    Array.isArray(roleEdge) &&
    roleEdge.map((site, index) =>
      site !== null ? (
        <SiteRoleComponents
          key={index}
          site={site}
          index={index}
          handleFieldChange={handleFieldChange}
          remove={remove}
          userId={editObj.Id}
        />
      ) : null
    );
  const fileUpload = (file) => {
    setFilename(file.name);
    return true;
  };

  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="1">
        <DownloadOutlined /> {translation('Download without data')}
      </Menu.Item>
      <Menu.Item key="2">
        <DownloadOutlined /> {translation('Download with data')}
      </Menu.Item>
    </Menu>
  );
  const handleVisibleChange = (visible) => {
    setVisible1(visible);
  };

  const handleChangeFile = (info) => {
    if (info.file.status === 'done') {
      message.success(`${info.file.name} file uploaded successfully`);
      _getUserList();
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  };

  let columns = [
    {
      title: translation('First Name'),
      dataIndex: 'FirstName',
      key: 'FirstName',
      ...getColumnSearchProps('FirstName')
    },
    {
      title: translation('Last Name'),
      dataIndex: 'LastName',
      key: 'LastName',
      ...getColumnSearchProps('LastName')
    },
    {
      title: translation('User Name'),
      dataIndex: 'UserName',
      key: 'UserName',
      ...getColumnSearchProps('UserName')
    },
    {
      title: translation('Email'),
      dataIndex: 'Email',
      key: 'Email',
      ...getColumnSearchProps('Email')
    },
    {
      title: translation('Action'),
      dataIndex: '',
      key: '',
      render: (text, record) => {
        if (record && record.Default !== true) {
          return (
            <div>
              <Tooltip title={translation('Edit')}>
                <Button
                  type="primary"
                  onClick={() => editUser(record)}
                  style={{ marginRight: '10px' }}

                >
                  <EditOutlined />
                </Button>
              </Tooltip>
              <Popconfirm
                title={translation('Are you sure delete User ?')}
                onConfirm={(e) => {
                  e.stopPropagation();
                  deleteUser(record.Id);
                }}
                okText={translation('Yes')}
                cancelText={translation('No')}
              >
                <Tooltip title={translation('Delete')}>
                  <Button
                    type="primary"
                    style={{ marginRight: '10px' }}>
                    <DeleteOutlined />
                  </Button>
                </Tooltip>
              </Popconfirm>

              <Tooltip title={translation('Reset Password')}>
                <Button type="primary"
                  onClick={() => {
                    resetpassword(record);
                  }}
                >
                  <RetweetOutlined />
                </Button>
              </Tooltip>
            </div>
          );
        }
      }
    }
  ];
  let formStructure = [
    {
      DisplayName: 'Salutation',
      Key: 'Salutation',
      Widget: 'Select',
      Options: ['Ms', 'Mr', 'Mrs', 'Jr', 'Sr'],
      Placeholder: 'Salutation',
      Required: true
    },
    {
      DisplayName: 'FirstName',
      Key: 'FirstName',
      Widget: 'Input',
      Placeholder: 'FirstName',
      Required: true
    },
    {
      DisplayName: 'LastName',
      Key: 'LastName',
      Widget: 'Input',
      Placeholder: 'LastName',
      Required: true
    },
    {
      DisplayName: 'UserName',
      Key: 'UserName',
      Widget: 'Input',
      disableOnUpdate: true,
      Placeholder: 'UserName',
      Required: true
    },
    {
      DisplayName: 'Email',
      Key: 'Email',
      Widget: 'Input',
      disableOnUpdate: true,
      Placeholder: 'Email',
      Required: true
    },
    {
      DisplayName: 'Mobile Number',
      Key: 'MobileNumber',
      Widget: 'InputNumber',
      disableOnUpdate: true,
      Placeholder: 'MobileNumber',
      Required: true
    },
    {
      DisplayName: 'Department',
      Key: 'DepartmentId',
      Widget: 'Select',
      Placeholder: 'Department',
      Options: departmentList,
      Required: true,
      OptionsSettings: { key: 'Name', value: 'Id' }
    },
    {
      DisplayName: 'Session Time (Mins)',
      Key: 'SessionTime',
      Widget: 'InputNumber',
      disableOnUpdate: false,
      Placeholder: 'Session Time',
      Required: true
    },
  ];
  const bulkUploadprops = {
    name: 'file',
    method: 'POST',
    action: `${GETUSERLIST.BULK}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    // Pass filename as extra data if needed
    data: () => ({
      filename
    }),
    onChange: handleChangeFile
  };

  return (
    <>
      <Drawer
        title={!editObj.Id ? translation('Create User') : translation('Update User')}
        open={visible}
        width={600}
        closable
        onClose={_cancel}
      >
        <Form
          layout="vertical"
          ref={userRef}
          name="user_form"
          labelCol={{ span: 10 }}
          wrapperCol={{ span: 14 }}
          initialValues={editObj || {}}
          style={{ marginBottom: '40px' }}
          onFinishFailed={onFinishFailed}
        >
          {editObj.Id === userId ? (
            <Form.Item
              label={translation('Upload')}
              name="upload"
              rules={[{ required: true, message: 'upload!' }]}
            >
              <span>
                <ImgCrop width={width} height={height}>
                  <Upload
                    name="file"
                    listType="picture-card"
                    className="avatar-uploader"
                    showUploadList={false}
                    action={`${GETUSERLIST.LogoUpload}?SiteId=${siteId}&UserName=${UserName}`}
                    headers={{
                      Authorization: Authorization
                    }}
                    beforeUpload={beforeUpload}
                    onChange={handleChange}
                  >
                    {imageUrl ? (
                      <img src={`/api/${imageUrl}`} height="100px" alt="avatar" />
                    ) : (
                      uploadButton
                    )}
                  </Upload>
                </ImgCrop>
              </span>
            </Form.Item>
          ) : null}

          {formStructure &&
            Array.isArray(formStructure) &&
            formStructure.map((formItem, index) => {
              return (
                <Form.Item
                  key={index}
                  name={formItem.Key}
                  label={translation(formItem.DisplayName)}
                  rules={[
                    {
                      required: formItem.Required,
                      message: translation(`${formItem.DisplayName} is required`)
                    }
                  ]}
                >
                  {renderFormSwitch(formItem)}
                </Form.Item>
              );
            })}

          <Divider>{translation('SiteRole')}</Divider>
          <Form.Item>
            <Button type="dashed" onClick={add}>
              <PlusOutlined />
              {translation('Add Item')}
            </Button>
          </Form.Item>
          {formItems}
        </Form>

        <DrawerFooter>
          <Button onClick={_cancel} type="primary" style={{ marginRight: 8 }}>
            {translation('Cancel')}
          </Button>
          {!editObj.Id ? (
            <Button type="primary" onClick={_createUser}>
              {translation('Create')}
            </Button>
          ) : (
            <Button type="primary" onClick={_updateUser}>
              {translation('Update')}
            </Button>
          )}
        </DrawerFooter>
      </Drawer>
      <div style={{ display: "flex", flexDirection: "row-reverse", marginBottom: '10px', }}>

        <div style={{ display: "flex", marginLeft: "10px" }}>
          <Upload
            accept=".csv,.xml"
            multiple={false}
            beforeUpload={fileUpload}
            {...bulkUploadprops}
          >
            <Button type="primary" className="ant-btn">
              <UploadOutlined />
              {translation('Click to Upload')}
            </Button>
          </Upload>
          <div style={{ marginLeft: "10px" }}>
            <Dropdown
              overlay={menu}
              onVisibleChange={handleVisibleChange}
              visible={visible1}
            >
              <Button type="primary">
                <DownloadOutlined />
                {translation('Download')}
              </Button>
            </Dropdown>
          </div>
        </div>
        <Button
          type="primary"
          onClick={openModal}
        >
          <PlusOutlined /> {translation('Add')}
        </Button>
      </div>


      <StyledTable size="small"
        columns={columns}
        dataSource={
          datasource && Array.isArray(datasource) ?
            datasource.map((data, index) => { return { ...data, key: index }; }) : []
        }
        pagination={
          datasource.length > 10
            ? {
              pageSize: '10'
            }
            : false
        }
      />
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
    userProfile: state.LayoutReducer.loggedInProfile,
  };
};
export default connect(mapStateToProps)(User);
